import { memo } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
import { formatDuration } from 'customer-data-property-utils/formatDuration';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { parseNumericValue } from '../utils/parseNumericValue';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputDuration = props => {
  const {
    autoFocus,
    inputRef,
    onChange,
    value
  } = props;
  const numericValue = parseNumericValue(value);
  const displayValue = numericValue === null ? '' : formatDuration(value);
  return /*#__PURE__*/_jsx(UITextInput, Object.assign({}, getTransferrableProps(props), {
    onChange: onChange,
    autoFocus: autoFocus,
    inputRef: inputRef,
    value: displayValue || '',
    autoComplete: "off",
    readOnly: true
  }));
};
export default /*#__PURE__*/memo(PropertyInputDuration);